import { HandleChar, HandleCharResult, Maskit } from './types';
import { tokens } from './tokens';
import { valueOrEmptyString } from '@/utils/string';

const handleUnscapedChar = (params: HandleChar): HandleCharResult => {
  const { masker, char } = params;
  let { maskIdx, valueIdx, output } = params;
  valueIdx++;

  if (masker.pattern?.test(char)) {
    const final = masker.transform ? masker.transform(char) : char;
    output = `${output}${final}`;
    maskIdx++;
  }

  return { output, maskIdx, valueIdx };
};

const handleScapedChar = (params: HandleChar): HandleCharResult => {
  const { masker, mask, masked, char } = params;
  let { maskIdx, valueIdx, maskChar, output } = params;
  maskIdx++;

  if (masker?.escape) {
    maskIdx++;
    maskChar = mask[maskIdx];
  }
  if (masked) output = `${output}${maskChar}`;
  if (char === maskChar) valueIdx++;

  return { output, maskIdx, valueIdx };
};

const handleChar = (params: HandleChar): HandleCharResult => {
  const { masker } = params;
  const useUnscaped = masker && !masker.escape;
  const handler = useUnscaped ? handleUnscapedChar : handleScapedChar;

  return handler({ ...params });
};

const applyMask = (value: string, mask: string, masked: boolean) => {
  let output = '';
  let maskIdx = 0;
  let valueIdx = 0;

  while (maskIdx < mask.length && valueIdx < value.length) {
    const maskChar = mask[maskIdx];
    if (maskChar === 'x') {
      output += 'x';
      maskIdx++;
      valueIdx++;
    } else {
      const masker = tokens[maskChar];
      const char = value[valueIdx];

      const result = handleChar({ masker, mask, masked, output, char, maskChar, maskIdx, valueIdx });

      output = result.output;
      maskIdx = result.maskIdx;
      valueIdx = result.valueIdx;
    }
  }

  return { output, maskIdx };
};

const processOutput = (output: string, mask: string, maskIdx: number) => {
  let restOutput = '';
  let localMaskIdx = maskIdx;

  while (localMaskIdx < mask.length) {
    const maskChar = mask[localMaskIdx];

    if (tokens[maskChar]) {
      restOutput = '';
      break;
    }

    restOutput = `${restOutput}${maskChar}`;
    localMaskIdx++;
  }

  return `${output}${restOutput}`;
};

export const maskit: Maskit = (value, mask, masked = true) => {
  const validMask = valueOrEmptyString(mask);
  const validValue = valueOrEmptyString(value);
  const { output, maskIdx } = applyMask(validValue, validMask, masked);

  if (!masked) return output;

  return processOutput(output, mask, maskIdx);
};
